module.exports = __webpack_public_path__ + "static/31-Accenture-65cdac88b113f64a1c22f002ba099266.png";